<div pButton pRipple class="canvas p-button-text"
     [class.selected]="!!mediaSourceId()"
     [class.disabled]="disabled"
     [style.width]="canvasWidth" [style.height]="canvasHeight"
     (click)="openSelectionDialog()"
     (dragover)="onDragOver($event)"
     (dragleave)="onDragLeave($event)"
     (drop)="onDrop($event)">
  @if (canBeRemoved && !!mediaSourceId()) {
    <div class="cancel-image" pTooltip="Rimuovi l'immagine" (click)="removeMediaAction($event)">X</div>
  }
  <img *ngIf="mediaSource && mediaSource.path?.length" [src]="mediaSource.fullPath"
       class="img-fluid">
  <span *ngIf="!mediaSource" class="pi pi-image"></span>
  <div *ngIf="dragging" class="drag-overlay">Rilascia il file qui</div>
</div>
